jQuery( document ).ready( function( $ ){

    // Variables
    let $notifier_modal = $( '#simplistics_product_stock_email_notification_modal' );
    let product_id;

    // Comment Form
    $( 'form.comment-form .submit' ).on( 'click', function( e ){

        let $fields = $( '.comment-form' ).find( '[required]' );
        let valid   = true;
        
        $fields.each( function(){
            removeError( $( this ) );
            let val = $( this ).val();
            if( ! val ){
                showError( $( this ) );
                valid = false;
            }
        });

        if( ! valid ){
            e.preventDefault();
            e.stopPropagation();
        }
        
    });

    function showError( $field ){
        $field.after( '<span class="error">'+ simplisticsAjax.translations.required +'</span>' )
    }

    function removeError( $field ){
        $field.next( '.error' ).remove();
    }

    // Product Thumbnails
    $( document ).on( 'click', '.product-gallery-thumbnail', function(){
        if( $( this ).hasClass( 'active' ) ){
            return;
        }
        let src         = $( this ).attr( 'data-source' );
        let $img        = $( '.woocommerce-product-gallery__image .wp-post-image' );
        $.when( $img.fadeOut( 300 ) ).done( () => {
            $img.attr( 'src', src );
            $img.attr( 'data-src', src );
            $img.attr( 'data-large_image', src );
            $img.removeAttr( 'srcset' );
            $img.fadeIn( 300 );
        });
        $( '.product-gallery-thumbnail' ).removeClass( 'active' );
        $( this ).addClass( 'active' );
    });

    // Notify when out of stock
    $( document ).on( 'click', '#notify-when-back-in-stock', function( e ){
        e.preventDefault();
        product_id = $( this ).attr( 'data-product' );
        let data = {
            'product': product_id,
            'action': 'simplistics_notify_when_in_stock',
            'nonce': simplisticsAjax.nonce
        };
        $.post( simplisticsAjax.url, data, ( res ) => {
            let response = JSON.parse( res );
            if( response.success ){
                let inserted    = response.inserted;
                if( inserted ){
                    // This person is now registered to be notified
                    window.location.reload();
                }
                else{
                    // Trigger popup to allow user to enter email
                    $notifier_modal.modal( 'show' );
                }
            }
            else{
                console.log( response.error );
            }
        });
    });

    // On email submit
    $( '#simplistics_product_stock_email_notification_submit_email' ).on( 'click', function(){
       
        let email       = $( '#notify_email_address' ).val();
        let first       = $( '#notify_first_name' ).val();
        let last        = $( '#notify_last_name' ).val();
        let notify      = $( '#notify_newsletter_checkbox' ).is( ':checked' );

        if( '' == email || '' == first || '' == last ){
            $notifier_modal.find( '.error' ).html( simplisticsAjax.translations.required );
            return;
        }
        
        $notifier_modal.find( '.error' ).html( '' );
        let data = {
            'product': product_id,
            'action': 'simplistics_notify_when_in_stock_email',
            'nonce': simplisticsAjax.nonce,
            'email': email,
            'first': first,
            'last': last,
            'sm_checked': notify
        };
        $.post( simplisticsAjax.url, data, ( res ) => {
            let response = JSON.parse( res );
            if( response.success ){
                // This needs to be translatable
                $notifier_modal.find( '.modal-body' ).html( simplisticsAjax.translations.success );
                $( '#notify-when-back-in-stock' ).hide();
                $( '#simplistics_product_stock_email_notification_submit_email' ).attr( 'disabled', true );
            }
        });
    });

    // Set product Banner position
    $( document ).ready( function(){

        setTimeout( function(){
            let info_height     = $( '.product__banner' ).closest( '.container' ).find( '.col:first-child' ).height();
            let banner_height   = $( '.product__banner' ).height();
    
            if( info_height > banner_height ){
                let padding_top =  ( info_height - banner_height ) / 2;
                $( '.product__banner' ).css( { 'padding-top': padding_top + 'px' } );
            }
        }, 200 );

    });

    $( document ).ready( function(){
    if (window.matchMedia("(min-width: 1024px)").matches && $('.added_to_cart').length) {
        $('.added_to_cart .wc-menu-cart').addClass('o-0').addClass('d-block');
        setTimeout(function(){ 
            $('.added_to_cart .wc-menu-cart').addClass('o-100');
        }, 1);
        setTimeout(function(){ 
            $('.added_to_cart .wc-menu-cart').removeClass('o-100');
        }, 2000);
        setTimeout(function(){ 
            $('.added_to_cart .wc-menu-cart').removeClass('o-0')
            $('.added_to_cart .wc-menu-cart').removeClass('d-block');
            $('.woocommerce.woo-cart').removeClass('added_to_cart');
            $('.header__navigation').removeClass('is-hover');
        }, 2350);
        setTimeout(function(){ 
            $('.added_to_cart .wc-menu-cart').addClass('o-100');
            $('.woocommerce.woo-cart .wc-menu-cart').attr('style', 'display: none;')
        }, 1);
    }
    });

});